import { deserializeSearchFilter, deserializeIncludeDiscontinuedFilter } from '../utils/deserialize-search-filter';
import { getSearchFilterIndex } from '../utils/get-search-filter-index';
import { getIncludeDiscontinuedFilterIndex } from '../utils/get-include-discontinued-filter-index';
var QueryBuilderService = (function () {
    function QueryBuilderService() {
    }
    QueryBuilderService.prototype.getIncludeDiscontinued = function (selectedFilters) {
        var includeDiscontinuedFilterIndex = getIncludeDiscontinuedFilterIndex(selectedFilters);
        if (includeDiscontinuedFilterIndex > -1) {
            var discontinuedQuery = deserializeIncludeDiscontinuedFilter(selectedFilters[includeDiscontinuedFilterIndex]);
            return discontinuedQuery.searchQuery;
        }
        return null;
    };
    QueryBuilderService.prototype.getIncludeDiscontinuedType = function (selectedFilters) {
        var includeDiscontinued = this.getIncludeDiscontinued(selectedFilters);
        if (!includeDiscontinued) {
            return null;
        }
        if (includeDiscontinued === "true") {
            return "supported";
        }
        return null;
    };
    QueryBuilderService.prototype.build = function (filterGroups, selectedFilters) {
        if (filterGroups === void 0) { filterGroups = []; }
        if (selectedFilters === void 0) { selectedFilters = []; }
        var query = '';
        for (var _i = 0, filterGroups_1 = filterGroups; _i < filterGroups_1.length; _i++) {
            var filterGroup = filterGroups_1[_i];
            var filterGroupQuery = '';
            var selectedGroupFilters = filterGroup.filters
                .filter(function (f) { return selectedFilters.indexOf(f.id) > -1; });
            for (var _a = 0, selectedGroupFilters_1 = selectedGroupFilters; _a < selectedGroupFilters_1.length; _a++) {
                var filter = selectedGroupFilters_1[_a];
                var filterQuery = '';
                if (filter.query) {
                    filterQuery = filter.query;
                }
                if (filterQuery !== '') {
                    filterGroupQuery += (filterGroupQuery === '' ? '' : ' or ') + filterQuery;
                }
            }
            if (filterGroupQuery === '') {
                continue;
            }
            if (query === '') {
                query += '(' + filterGroupQuery + ')';
            }
            else {
                query += ' and (' + filterGroupQuery + ')';
            }
        }
        var searchFilterIndex = getSearchFilterIndex(selectedFilters);
        if (searchFilterIndex > -1) {
            var searchFilterObject = deserializeSearchFilter(selectedFilters[searchFilterIndex]);
            var searchFilterQuery = searchFilterObject.searchQuery;
            if (searchFilterQuery) {
                if (query !== '') {
                    query += ' and ';
                }
                query += "search.ismatch('" + searchFilterQuery.split(' ').join('*+') + "*', 'familyName,title')";
            }
        }
        return query;
    };
    QueryBuilderService.$inject = [];
    return QueryBuilderService;
}());
export { QueryBuilderService };
